import { Eyebrow, Reveal } from "./Reveal";

const CONTENTS = [
  "An executive summary for the Board, with an overall residual-exposure rating.",
  "The spaces examined, with date and time of attendance.",
  "The methods and instruments used, and the conditions and limits of the inspection.",
  "Each recorded finding: what was found and where, why it matters, our confidence, and our recommendation with a suggested owner and timing, supported by photographs and instrument captures.",
  "Technical appendices: the radio-frequency analysis and the evidence behind the findings.",
];

export default function ReportingStrip() {
  return (
    <section id="reporting" className="border-t border-hairline py-12 sm:py-16" data-testid="reporting-section">
      <div className="site-x">
        <Reveal>
          <Eyebrow>Reporting</Eyebrow>
          <h2 className="mt-4 font-head font-extrabold tracking-tight h-sec">
            In writing, every time.
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-sub">
            Every inspection ends in a written report and a verbal debrief:
            what was examined, what was found within the recorded conditions,
            and what we recommend. Sealed, and delivered to the person who
            engaged us.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-2">
          <Reveal>
            <h4 className="text-xs font-semibold uppercase tracking-[0.16em] text-violet">
              What the report contains
            </h4>
            <ol className="mt-6 flex flex-col gap-4" data-testid="report-contents-list">
              {CONTENTS.map((item, i) => (
                <li key={item} className="flex items-start gap-4 text-[0.9375rem] leading-relaxed">
                  <span className="mt-0.5 text-xs font-semibold tracking-[0.16em] text-violet">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ol>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex h-full flex-col justify-between border border-hairline bg-surface p-7 sm:p-9">
              <p className="text-base leading-relaxed text-sub">
                Evidence photographs of findings are included. How they are
                taken is set out under Confidentiality below.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
